import React from "react";
import {Card, CardActions, CardContent, Divider} from "@mui/material";
import {CardData, UserAvatar} from "@atttomyx/react-components";
import {datetime} from "@atttomyx/shared-utils";
import {formatPhone} from "../../utils/nodes";

const ContactCard = (props) => {
    const { contact, filters, children } = props;

    return <Card className="contact-card" raised={true}>
        <CardContent>
            <UserAvatar user={contact} mode="right"/>
            <Divider/>
            <CardData
                filters={filters}
                data={contact}
                keyToMetadata={{
                    firstName: {
                        title: "First Name",
                    },
                    lastName: {
                        title: "Last Name",
                    },
                    email: {
                        title: "Email",
                    },
                    phone: {
                        title: "Phone",
                        formatter: formatPhone,
                    },
                    leadSource: {
                        title: "Lead Source",
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default ContactCard;
